query GetCaseTypes {
  caseTypes {
    id
    name
    description
    salesforceId
  }
}
